__turbopack_context__.v({
  "brand": "floating-site-chrome-module__WtGTjW__brand",
  "brandLink": "floating-site-chrome-module__WtGTjW__brandLink",
  "caption": "floating-site-chrome-module__WtGTjW__caption",
  "desktopLinks": "floating-site-chrome-module__WtGTjW__desktopLinks",
  "divider": "floating-site-chrome-module__WtGTjW__divider",
  "footer": "floating-site-chrome-module__WtGTjW__footer",
  "footerBottom": "floating-site-chrome-module__WtGTjW__footerBottom",
  "footerInner": "floating-site-chrome-module__WtGTjW__footerInner",
  "footerLinks": "floating-site-chrome-module__WtGTjW__footerLinks",
  "footerRow": "floating-site-chrome-module__WtGTjW__footerRow",
  "footerTagline": "floating-site-chrome-module__WtGTjW__footerTagline",
  "footerText": "floating-site-chrome-module__WtGTjW__footerText",
  "groupLinks": "floating-site-chrome-module__WtGTjW__groupLinks",
  "header": "floating-site-chrome-module__WtGTjW__header",
  "inlineWordmark": "floating-site-chrome-module__WtGTjW__inlineWordmark",
  "linkGroup": "floating-site-chrome-module__WtGTjW__linkGroup",
  "logo": "floating-site-chrome-module__WtGTjW__logo",
  "mobileLinks": "floating-site-chrome-module__WtGTjW__mobileLinks",
  "particles": "floating-site-chrome-module__WtGTjW__particles",
  "pill": "floating-site-chrome-module__WtGTjW__pill",
  "previewBooking": "floating-site-chrome-module__WtGTjW__previewBooking",
  "previewLanguage": "floating-site-chrome-module__WtGTjW__previewLanguage",
  "previewSignIn": "floating-site-chrome-module__WtGTjW__previewSignIn",
  "toggle": "floating-site-chrome-module__WtGTjW__toggle",
  "wordmark": "floating-site-chrome-module__WtGTjW__wordmark",
});
